/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

import React, { Children } from 'react';
import PropTypes from 'prop-types';
import EventManager from '../EventManager';
import AnalyticsManager from '../AnalyticsManager';

export default class EventProvider extends React.Component {
  static childContextTypes = {
    eventManager: PropTypes.shape({
      dispatch: PropTypes.func.isRequired
    }).isRequired,
    onEvent: PropTypes.func
  };

  constructor(props) {
    super(props);
    EventProvider.eventManager = new EventManager(props);
    EventProvider.onEvent = props.onEvent;
    AnalyticsManager.setContext(props);
  }

  getChildContext() {
    return {
      eventManager: EventProvider.eventManager,
      onEvent: EventProvider.onEvent
    };
  }

  static getEventManager() {
    return EventProvider.eventManager;
  }

  render() {
    const { children } = this.props;
    return Children.only(children);
  }
}
EventProvider.propTypes = {
  children: PropTypes.element.isRequired,
  onEvent: PropTypes.func
};

EventProvider.defaultProps = {
  disableAnalytics: false, // eslint-disable-line
  onEvent: () => {} // eslint-disable-line
};



// WEBPACK FOOTER //
// ./src/js/providers/EventProvider.jsx